import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CharacteristicSelect from 'Components/characteristicSelect';
import SelectIndicatorsBundleToolbox from 'Components/selectIndicatorsBundleToolbox';
import { makeIndicatorWithId } from 'Selectors/indicatorWithId';
import * as styles from './selectIndicatorsInputToolbox.css';

class SelectIndicatorsInputToolbox extends Component {
  constructor(props) {
    super(props);

    this.state = this.props;
    this.onChange = this.onChange.bind(this);
  }

  onChange(indicator, hasData = true) {
    this.setState((prevState) => ({
      checked: !prevState.checked,
      allChecked: !hasData,
      deselectAll: false === !prevState.checked,
    }));
    this.props.onIndicatorChange(`${indicator}`, !this.state.checked, hasData);
  }

  render() {
    const { checked, deselectAll } = this.state;
    const { catHash, characteristics, fullId } = this.props;
    let compoundId = this.props.id;
    if (catHash) {
      compoundId = `${this.props.id}|${catHash}`;
    }

    return !this.props.children ? (
      <div className={styles.indicator} key={fullId}>
        <span className={styles.span}>
          <input
            className={styles.input}
            checked={checked}
            id={compoundId}
            type="checkbox"
            onChange={() =>
              this.onChange(compoundId, characteristics.hasData)
            }
          />
          <label htmlFor={compoundId} className={styles.label}>
            {this.props.label}
          </label>
        </span>
        {!0 < Object.keys(this.props.characteristics).length ? (
          <ul className={styles.indicatorGroup}>
            <li>
              <CharacteristicSelect
                characteristics={characteristics.values}
                onChange={this.props.onCharacteristicChange}
                indicator={characteristics.indicator}
                fullId={fullId}
                catHash={catHash}
                hasData={characteristics.hasData}
                selectAll={checked}
                deselectAll={deselectAll}
              />
            </li>
          </ul>
        ) : null}
      </div>
    ) : (
      <SelectIndicatorsBundleToolbox
        id={this.props.id}
        fullId={fullId}
        catHash={catHash}
        key={fullId}
        onIndicatorChange={this.props.onIndicatorChange}
        onCharacteristicChange={this.props.onCharacteristicChange}
        characteristics={this.props.characteristics}
      />
    );
  }
}

SelectIndicatorsInputToolbox.defaultProps = {
  catHash: null,
  checked: false,
  children: false,
  fullId: undefined,
};

SelectIndicatorsInputToolbox.propTypes = {
  id: PropTypes.number.isRequired,
  fullId: PropTypes.string,
  catHash: PropTypes.string,
  label: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.bool,
  ]),
  onIndicatorChange: PropTypes.func.isRequired,
  onCharacteristicChange: PropTypes.func.isRequired,
  characteristics: PropTypes.object.isRequired,
};

const mapStateToProps = (state, props) => {
  const indicator = makeIndicatorWithId()(state, props);
  const characteristics = {
    ...props.characteristics,
    hasData: true,
  };
  // If an indicator has no characteristics, we will get them from the
  // state data.  This will allow us to show all characteristics.
  // disabled property is due to this particular indicator not being a part
  // of the table yet.
  return {
    ...indicator,
    characteristics:
      Object.keys(props.characteristics).length ? characteristics :
      {
        indicator: `${props.id}`,
        hasData: false,
        values: [],
      },
  };
};

export default connect(mapStateToProps)(SelectIndicatorsInputToolbox);

// Testing exports
export { SelectIndicatorsInputToolbox };



// WEBPACK FOOTER //
// ./app/components/selectIndicatorsInputToolbox/index.js